import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.scss']
})
export class UnitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
